export default __webpack_public_path__ + "static/media/carousel-placeholder0.65030ab9.gif";